import React from 'react'
import { IoIosArrowForward } from 'react-icons/io'
import { Link } from 'react-router-dom';

function DownloadCardStd({ preview, fileName, files, Iconcolor, Textcolor, BtIColor }) {
  const { file1, file2, file3, file4 } = files;
  return (
    <div>
      <div className="contactOptions2 ">
        {/* 
              <h4 style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}>
              
                {headlines?.filesHeadline ? headlines?.filesHeadline : ('files', 'Downloads')}
              </h4> */}

        {fileName?.fileName1 ? (
          <div className="social-mediafiles relative">
            <Link
              to={`${preview ? file1 : ""}`}
              target={`${preview ? "_blank" : ""}`}
              className=""
            >
              <div className="social-mediafilesimg " style={{ background: `${Iconcolor ? Iconcolor : "black"}` }}>
                <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.25 1.75V9.25H18.75" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linejoin="round" />
                </svg>


              </div>
              <h5
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                }}
              >
                {" "}
                {fileName?.fileName1}
              </h5>
            </Link>
            <svg width="16" height="16" className="absolute right-5 top-[35%]" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.66669 2V8.39067L11 6.05733L11.9427 7L8.00002 10.9427L4.05735 7L5.00002 6.05733L7.33335 8.39067V2H8.66669ZM3.00002 9.33333V12.6667H13V9.33333H14.3334V14H1.66669V9.33333H3.00002Z" fill={BtIColor ? BtIColor : "black"} />
            </svg>

            {/* <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} /> */}
          </div>
        ) : (
          ""
        )}

        {fileName?.fileName2 ? (
       
          <div className="social-mediafiles relative">
            <Link
              to={`${preview ? file2 : ""}`}
              target={`${preview ? "_blank" : ""}`}
              className=""
            >
              <div className="social-mediafilesimg " style={{ background: `${Iconcolor ? Iconcolor : "black"}` }}>
                <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.25 1.75V9.25H18.75" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linejoin="round" />
                </svg>


              </div>
              <h5
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                }}
              >
                {" "}
                {fileName?.fileName2}
              </h5>
            </Link>
            <svg width="16" height="16" className="absolute right-5 top-[35%]" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.66669 2V8.39067L11 6.05733L11.9427 7L8.00002 10.9427L4.05735 7L5.00002 6.05733L7.33335 8.39067V2H8.66669ZM3.00002 9.33333V12.6667H13V9.33333H14.3334V14H1.66669V9.33333H3.00002Z" fill={BtIColor ? BtIColor : "black"} />
            </svg>

            {/* <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} /> */}
          </div>
        ) : (
          ""
        )}

        {fileName?.fileName3 ? (
         
          <div className="social-mediafiles relative">
          <Link
            to={`${preview ? file3 : ""}`}
            target={`${preview ? "_blank" : ""}`}
            className=""
          >
            <div className="social-mediafilesimg " style={{ background: `${Iconcolor ? Iconcolor : "black"}` }}>
              <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.25 1.75V9.25H18.75" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linejoin="round" />
              </svg>


            </div>
            <h5
              style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}
            >
              {" "}
              {fileName?.fileName3}
            </h5>
          </Link>
          <svg width="16" height="16" className="absolute right-5 top-[35%]" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.66669 2V8.39067L11 6.05733L11.9427 7L8.00002 10.9427L4.05735 7L5.00002 6.05733L7.33335 8.39067V2H8.66669ZM3.00002 9.33333V12.6667H13V9.33333H14.3334V14H1.66669V9.33333H3.00002Z" fill={BtIColor ? BtIColor : "black"} />
          </svg>

          {/* <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} /> */}
        </div>
        ) : (
          ""
        )}

        {fileName?.fileName4 ? (
         <div className="social-mediafiles relative">
         <Link
           to={`${preview ? file4 : ""}`}
           target={`${preview ? "_blank" : ""}`}
           className=""
         >
           <div className="social-mediafilesimg " style={{ background: `${Iconcolor ? Iconcolor : "black"}` }}>
             <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round" />
               <path d="M11.25 1.75V9.25H18.75" stroke={BtIColor ? BtIColor : "black"} stroke-width="1.875" stroke-linejoin="round" />
             </svg>


           </div>
           <h5
             style={{
               color: `${Textcolor ? Textcolor : ""}`,
             }}
           >
             {" "}
             {fileName?.fileName4}
           </h5>
         </Link>
         <svg width="16" height="16" className="absolute right-5 top-[35%]" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M8.66669 2V8.39067L11 6.05733L11.9427 7L8.00002 10.9427L4.05735 7L5.00002 6.05733L7.33335 8.39067V2H8.66669ZM3.00002 9.33333V12.6667H13V9.33333H14.3334V14H1.66669V9.33333H3.00002Z" fill={BtIColor ? BtIColor : "black"} />
         </svg>

         {/* <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} /> */}
       </div>
        ) : (
          ""
        )}
      </div>
    </div>
  )
}

export default DownloadCardStd